import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Buefy from "buefy";
Vue.use(Buefy);
import "@mdi/font/css/materialdesignicons.css";

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
Vue.use(PerfectScrollbar);

import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, min, max, min_value, max_value, regex, numeric } from 'vee-validate/dist/rules';

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

extend('required', {...required, message: "{_field_} ist ein Pflichtfeld"});
extend('min', {...min, message: "{_field_} muss mindestens {length} Zeichen lang sein"});
extend('max', {...max, message: "{_field_} darf maximal {length} Zeichen lang sein"});
extend('min_value', {...min_value, message: "{_field_} muss größer als {min} sein"});
extend('max_value', {...max_value, message: "{_field_} muss kleiner als {max} sein"});
extend('email', {...email, message: "{_field_} muss eine gültige E-Mail-Adresse sein"});
extend('currency', {...regex, message: "{_field_} muss numerisch sein und exakt 2 Nachkommastellen enthalten."});
extend('float', {...regex, message: "{_field_} muss eine Zahl mit Punkt sein."});
extend('numeric', {...numeric, message: "{_field_} muss eine Zahl sein."});

import VueEditor from "vue2-editor";
Vue.use(VueEditor);

// Currency Filter
Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});

// Fields
import {
  parentIdField,
  ownerIdField,
  cleanerIdField,
  nameField,
  codeField,
  urlField,
  streetField,
  zipField,
  cityField,
  countryField,
  bedsField,
  bedroomsField,
  bathroomsField,
  roomsField,
  latitudeField,
  longitudeField,
  personsField,
  squareMetersField,
  metersToBeachField,
  floorField,
  shortDescriptionField,
  longDescriptionField,
  contractDescriptionField
} from "@/components/atoms/fields";

import BackButton from '@/components/atoms/BackButton.vue'
Vue.component('BackButton', BackButton)

Vue.component('parentIdField', parentIdField)
Vue.component('ownerIdField', ownerIdField)
Vue.component('cleanerIdField', cleanerIdField)
Vue.component('nameField', nameField)
Vue.component('codeField', codeField)
Vue.component('urlField', urlField)
Vue.component('streetField', streetField)
Vue.component('zipField', zipField)
Vue.component('cityField', cityField)
Vue.component('countryField', countryField)
Vue.component('bedsField', bedsField)
Vue.component('bedroomsField', bedroomsField)
Vue.component('bathroomsField', bathroomsField)
Vue.component('roomsField', roomsField)
Vue.component('latitudeField', latitudeField)
Vue.component('longitudeField', longitudeField)
Vue.component('personsField', personsField)
Vue.component('squareMetersField', squareMetersField)
Vue.component('metersToBeachField', metersToBeachField)
Vue.component('floorField', floorField)
Vue.component('shortDescriptionField', shortDescriptionField)
Vue.component('longDescriptionField', longDescriptionField)
Vue.component('contractDescriptionField', contractDescriptionField)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
